import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import UpsellChip from '~/Common-Objects/UI/Chips/Upsell.jsx'
import i18n from '~/i18n'
import BrandingSplash from '~/Common-Objects/Onboarding/splashes/branding.png'
import AiBadge from '~/Common-Objects/Icons/AiBadge'
import { OnboardingStep } from '~/Common-Objects/Onboarding'

export default function BrandStep({ isOpen, isComplete, onClick, onAnalyze, postHogTag }) {
    return (
        <OnboardingStep
            key='brand'
            title={<>{i18n.t('setup:steps.analyse-brand.title')}<UpsellChip icon="sparkle">AI</UpsellChip></>}
            icon={<Icons icon='brandAnalyser' color='currentColor' />}
            isOpen={isOpen}
            isComplete={isComplete}
            onClick={onClick}
        >
            <p>{i18n.t('setup:steps.analyse-brand.content')}</p>
            <div>
                <Button
                    className='button-primary button-small'
                    iconRight={<Icons icon='arrowRight' />}
                    onClick={(e) => {
                        e.stopPropagation()
                        onAnalyze()
                    }}
                    postHogTag={postHogTag}
                >
                    {i18n.t('setup:steps.analyse-brand.button-text')}
                </Button>
            </div>
        </OnboardingStep>
    )
}

BrandStep.splash = <img src={BrandingSplash} alt={i18n.t('setup:steps.analyse-brand.title')} />
